module.exports = __webpack_public_path__ + "img/introduce02_right.e1ed9fdf.png";